import { IPickerOption, MenuObject } from '@rbi-ctg/menu';
import { MenuObjectTypes } from 'enums/menu';

export const buildEntitiesWithBadgeMap = (menu: MenuObject[], requirementsSet: Set<string>) => {
  return (menu || []).reduce((menuIds: Set<string>, section: MenuObject) => {
    (section?.options || []).forEach(option => {
      if (
        (option._type === MenuObjectTypes.ITEM || option._type === MenuObjectTypes.COMBO) &&
        requirementsSet.has(option._id)
      ) {
        menuIds.add(option._id);
        menuIds.add(section._id);
      } else if (option._type === MenuObjectTypes.PICKER) {
        option.options.forEach((pickerOption: IPickerOption) => {
          if (requirementsSet.has(pickerOption.option._id)) {
            menuIds.add(option._id);
            menuIds.add(section._id);
          }
        });
      }
    });
    return menuIds;
  }, new Set<string>());
};

// @TODO: Add util function for PDP
